import React from 'react';
import Button from '@result/result-ui-components/src/components/Button';

const SearchInput = ({
	value,
	onChange,
	onEnter,
	onClick,
	placeholder,
	isLoading,
}) => {
	return (
		<div className="search-input">
			<input
				value={value}
				className="input"
				onChange={(e) => {
					onChange(e.target.value);
				}}
				placeholder={placeholder}
				onKeyDown={(e) => {
					e.key === 'Enter' ? onEnter(value) : '';
				}}
				disabled={isLoading}
			/>
			<Button
				className="fz fz-magnifying-glass-1"
				isOutlined={true}
				isLoading={isLoading}
				disabled={value?.trim()?.length > 0 ? false : true}
				onClick={() => (value?.trim()?.length > 0 ? onClick(value) : '')}
			/>
		</div>
	);
};

export default SearchInput;
